// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\StripeConnectSessionResponse

export type StripeConnectSessionApiResponse = {
	clientSecret: string;
};

export type StripeConnectSession = {
	clientSecret: string;
};

export function hydrateStripeConnectSession(data: StripeConnectSessionApiResponse): StripeConnectSession {
	return { ...data };
}